<div class="detail-dialog">

    <mat-tab-group [(selectedIndex)]="nutritionTabIndex" class="tabs" dynamicHeight>

        @for (nutritionId of nutritionEntries; track nutritionId) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="label">
                        <img alt="{{'NUTRITION.' + nutritionId.toUpperCase() | translate}}"
                              class="attribute-img" src="assets/images/nutrition/{{nutritionId}}.webp">
                        <p>{{ 'NUTRITION.' + nutritionId.toUpperCase() | translate }}</p>
                    </div>
                </ng-template>
                <article class="description">
                    <h2>
                        {{ 'NUTRITION.' + nutritionId.toUpperCase() | translate }}
                    </h2>
                    <p [innerHTML]="'NUTRITION_INFO.' + nutritionId.toUpperCase()  | translate"></p>
                </article>
            </mat-tab>
        }

    </mat-tab-group>


</div>
